import React from "react";
import logger from "logger";
import TaskDialog from "TaskDialogCommon/TaskDialog";
import RunButton from "TaskDialogCommon/RunButton";
import HeroNameSelector from "TaskDialogCommon/HeroNameSelector";
import TaskInput from "TaskDialogCommon/TaskInput";
import TaskCheckBox from "TaskDialogCommon/TaskCheckBox";
import errordialog from "Common/errordialog";
import TroopMapSelector from "TaskDialogCommon/TroopMapSelector";
import BossSelector from "TaskDialogCommon/BossSelector";
import { getLastConfigForTask } from "Utils/Common";

const taskname = "ebkrun";

export default class Component extends React.Component {
  constructor(props) {
    super();
    const { accountdetailrow } = props;
    const initialState = {
      taskConfig: {
        accountdetail: accountdetailrow,
        atkheroname: "",
        defheroname: "",
        summonbosses: false,
        killonlymybosses: false,
        selectedAlliBoss: {},
        mithhit: false,
        usestams: 999,
        unboxtroops: true,
        troopskiller: {},
        troopssummoner: {},
      },
    };
    logger.log("loading ebkrun dialog", props);
    this.loadStoredData(initialState, props);
    logger.log("initialState after load", initialState);
    this.state = initialState;
  }

  validate = () => {
    const {
      taskConfig: {
        atkheroname,
        troopskiller,
        selectedAlliBoss,
        summonbosses,
        defheroname,
        troopssummoner,
      },
    } = this.state;
    if (!atkheroname || atkheroname.length === 0) {
      alert("Please select a hero before continuing");
      return false;
    }
    if (!troopskiller || Object.keys(troopskiller).length === 0) {
      alert("Please select troops to use before continuing");
      return false;
    }
    if (!selectedAlliBoss || Object.keys(selectedAlliBoss).length === 0) {
      alert("Please select a boss before continuing");
      return false;
    }
    if (summonbosses) {
      if (!defheroname || defheroname.length === 0) {
        alert("Please select a hero to use for summoning before continuing");
        return false;
      }
      if (!troopssummoner || Object.keys(troopssummoner).length === 0) {
        alert("Please select troops to use for summoning before continuing");
        return false;
      }
    }
    return true;
  };

  loadStoredData = (initialState, props) => {
    const { taskConfig } = initialState;
    try {
      const { AccountDetailData: accountdetail } = props;
      var storeddata = getLastConfigForTask(taskname);
      if (storeddata) {
        for (var key in accountdetail.heroes) {
          var cityObj = accountdetail.heroes[key];
          for (var hkey in cityObj.cityheroes) {
            var heroObj = cityObj.cityheroes[hkey];
            if (heroObj.heroname === storeddata.atkheroname) {
              taskConfig.atkheroname = storeddata.atkheroname;
            }
            if (heroObj.heroname === storeddata.defheroname) {
              taskConfig.defheroname = storeddata.defheroname;
            }
          }
        }
        taskConfig.summonbosses = storeddata.summonbosses;
        taskConfig.killonlymybosses = storeddata.killonlymybosses;
        for (var key in accountdetail.allielitebosses) {
          var elitebossObj = accountdetail.allielitebosses[key];
          if (elitebossObj.bossid === storeddata.selectedAlliBoss.bossid) {
            taskConfig.selectedAlliBoss = elitebossObj;
            break;
          }
        }
        taskConfig.mithhit = storeddata.mithhit;
        taskConfig.usestams = storeddata.usestams;
        taskConfig.unboxtroops = storeddata.unboxtroops;
        taskConfig.troopskiller = { ...storeddata.troopskiller };
        taskConfig.troopssummoner = { ...storeddata.troopssummoner };
      }
    } catch (e) {
      logger.log(e);
    }
  };

  setValue = (event, key) => {
    const value = event.target.value;
    this.setState((s, p) => ({
      taskConfig: { ...s.taskConfig, [key]: value },
    }));
  };

  render = () => {
    const {
      setValue,
      validate,
      state: { taskConfig },
      props: { AccountDetailData },
    } = this;
    if (AccountDetailData.allielitebosses === undefined) {
      errordialog.showError(
        "Account does not seem to have access to Alliance Bosses. Please contact admin."
      );
      return null;
    }

    return (
      <TaskDialog heading={"EBK Run"}>
        <HeroNameSelector
          label={"Select Bosskill Hero"}
          AccountDetailData={AccountDetailData}
          taskConfig={taskConfig}
          setValue={setValue}
          param={"atkheroname"}
        />

        <TaskInput
          label={
            "Auto Pop 200% Attack Runes for mins before every hit(Optional)"
          }
          value={taskConfig.poprunesmins}
          onChange={(event) => setValue(event, "poprunesmins")}
        />

        <TaskCheckBox
          label={"Auto Unbox Troops when needed."}
          param={"unboxtroops"}
          taskConfig={taskConfig}
          setValue={setValue}
        />

        <TroopMapSelector
          AccountDetailData={AccountDetailData}
          taskConfig={taskConfig}
          setValue={setValue}
          label={"Add Troops To Send for killing boss"}
          param={"troopskiller"}
        />

        <TaskCheckBox
          label={"Summon Bosses as well."}
          param={"summonbosses"}
          taskConfig={taskConfig}
          setValue={setValue}
        />
        {taskConfig.summonbosses && (
          <>
            <TaskCheckBox
              label={"Kill only bosses summoned by me."}
              param={"killonlymybosses"}
              taskConfig={taskConfig}
              setValue={setValue}
            />
            <HeroNameSelector
              label={"Select boss summon hero"}
              AccountDetailData={AccountDetailData}
              taskConfig={taskConfig}
              setValue={setValue}
              param={"defheroname"}
            />
            <TroopMapSelector
              AccountDetailData={AccountDetailData}
              taskConfig={taskConfig}
              setValue={setValue}
              label={"Add Troops To Send for summoning"}
              param={"troopssummoner"}
            />
          </>
        )}

        <TaskCheckBox
          label={"Use mithril to hit bosses."}
          param={"mithhit"}
          taskConfig={taskConfig}
          setValue={setValue}
        />

        <BossSelector
          label={"Select boss to kill"}
          param={"selectedAlliBoss"}
          taskConfig={taskConfig}
          setValue={setValue}
          bosslist={AccountDetailData.allielitebosses}
        />

        <TaskInput
          label={"Max no of stamina to use for summoning:"}
          value={taskConfig.usestams}
          onChange={(event) => setValue(event, "usestams")}
        />

        <RunButton
          taskname={taskname}
          taskConfig={taskConfig}
          label={"Run EBK"}
          validate={validate}
        />
      </TaskDialog>
    );
  };
}
